import { render, staticRenderFns } from "./CountsCard.vue?vue&type=template&id=93f60670&scoped=true&"
import script from "./CountsCard.vue?vue&type=script&lang=ts&"
export * from "./CountsCard.vue?vue&type=script&lang=ts&"
import style0 from "./CountsCard.vue?vue&type=style&index=0&id=93f60670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f60670",
  null
  
)

export default component.exports